import { mapShapecodeToName } from "areas/product/store/helpers/diamond"

const displayOptionDescription = (wizardData, state, ownProps) => {
  const choiceData = state.choices[ownProps.pref]
  if (!wizardData) {
    return null
  }

  if (wizardData && wizardData.description) {
    return wizardData.description
  }
  if (wizardData.pref == "ef" || wizardData.pref == "ef2") {
    let desc = ""
    let sortedChoices = Object.keys(state.choices).sort()
    sortedChoices.forEach((key) => {
      if (
        key[0] == "e" &&
        key != "ef" &&
        key != "ef2" &&
        key != "ec" &&
        !state.choices[key].disabled &&
        !state.choices[key].is_default &&
        state.choices[key].value &&
        state.choices[key].value != "" &&
        !state.choices[key].settings_metal
      ) {
        if (state.choices[key]?.engraving_font !== wizardData.pref) return
        if (desc == "") {
          desc = state.choices[key].value
        } else {
          desc += ", " + state.choices[key].value
        }
      }
    })
    // if (desc === "") {
    //   desc = "Choose your engravings" //Default text for ring engravings
    // }
    return desc
  } else if (wizardData.pref == "sku") {
    let desc = ""
    if (state.choices.sku && state.choices.sku.full_title) {
      desc = state.choices.sku.full_title
    }
    return desc
  } else if (wizardData.pref == "sz") {
    //Default text for  ring or pendant size
    let desc = ""
    if (state.wizard.data.sz.not_a_ring) {
      //desc = "Choose your pendant size"
    } else {
      //desc = "Choose your ring size"
    }
    if (state.choices.sz && state.choices.sz.value) {
      desc = state.choices.sz.title
    }
    return desc
  } else if (wizardData.pref == "ch" || /ch[0-9]+$/.test(wizardData.pref)) {
    let desc = "" // "Choose your chain length" //Default text for chain length
    if (choiceData && choiceData.chain_length) {
      desc = choiceData.title
    }
    return desc
  } else if (wizardData.pref == "a1" || wizardData.pref == "a2") {
    let desc = "" //"Choose your charm (optional)" //Default text for charm option
    if (
      state.choices[wizardData.pref] &&
      state.choices[wizardData.pref].code &&
      !state.choices[wizardData.pref].disabled
    ) {
      desc = state.choices[wizardData.pref].title
      if (wizardData.heading.description) desc += wizardData.heading.description
    }
    return desc
  } else if (
    choiceData &&
    wizardData.options_display_labels &&
    Object.keys(wizardData.options_display_labels).length > 1
  ) {
    let desc = []
    const optionsDisplayLabels = wizardData.options_display_labels
    Object.keys(optionsDisplayLabels).forEach((pref) => {
      if (state.choices[pref] && state.choices[pref].title) {
        desc.push(`${optionsDisplayLabels[pref]}: ${state.choices[pref].title}`)
      }
    })
    return desc.join(", ")
  } else if (wizardData.settings_metal) {
    let desc = ""
    if (typeof choiceData !== "undefined") {
      desc = choiceData.title
    }
    if (state.diamondSelector.signatureBasket) {
      if (typeof state.choices.e1 !== "undefined") {
        desc +=
          (desc == "" ? "" : ", ") + "Side 1 Initial: " + state.choices.e1.value
      }
      if (typeof state.choices.e2 !== "undefined") {
        desc +=
          (desc == "" ? "" : ", ") + "Side 2 Initial: " + state.choices.e2.value
      }
    }
    return desc
  } else if (ownProps.pref == "diamond") {
    let desc = ""
    const diamond = state.diamondSelector.selected_diamond
    const showDesc =
      state.diamondUI.steps[state.diamondUI.currentStep] == "final_diamond" &&
      diamond
    if (showDesc) {
      const stoneType = state.diamondSelector.d_stone_type?.find(
        (s) => s.value === diamond.stone_type
      )
      if (stoneType) {
        desc = `${stoneType.title}, `
      }

      if (diamond?.shape && diamond.carat) {
        desc += `${mapShapecodeToName[diamond.shape]}, ${
          diamond.is_diamond ? `${diamond.carat}ct` : diamond.stone_size
        }`
      }
    }
    return desc
  } else {
    if (typeof choiceData === "undefined") {
      return ""
    } else {
      return choiceData.title
    }
  }
}

export default displayOptionDescription
